import React from "react";
import "./Header.css";

const Header = ({ isOfferPage, currentStep }) => {
  console.log(currentStep);
  isOfferPage = true;
  const logoSrc = isOfferPage
    ? "/assets/img/New_LOGO.svg"
    : "/assets/img/newLogo.png";

  return (
    <header className="header-abc-xyz">
      <img src={logoSrc} alt="Digit Money Logo" className="logo-img" />
      {currentStep === 1 && (
        <img
          src="/assets/img/tataCapital.png"
          alt="Aditya Birla Finance Logo"
          className="logo-img-abc"
        />
      )}
    </header>
  );
};

export default Header;
